export interface Manga {
  id: string;
  title: string;
  titleEn: string;
  author: string;
  categories: string[];
  status: "连载中" | "已完结";
  rating: number;
  views: string;
  cover: string;
  description: string;
  latestChapterId: string;
  latestChapter: string;
  chaptersCount: number;
  tags: string[];
  isHot?: boolean;
  isNew?: boolean;
  isFeatured?: boolean;
}

export const mangaList: Manga[] = [
  {
    id: "hitman-reborn",
    title: "家庭教师",
    titleEn: "家庭教师ヒットマンREBORN",
    author: "天野明",
    categories: ["hot-blooded", "battle", "school", "completed"],
    status: "已完结",
    rating: 9.8,
    views: "2.3亿",
    cover: "https://readdy.ai/api/search-image?query=Shonen%20manga%20cover%20illustration%20of%20a%20teenage%20boy%20with%20spiky%20brown%20hair%20holding%20a%20tiny%20baby%20hitman%20in%20a%20black%20suit%20and%20fedora%20on%20his%20shoulder%2C%20surrounded%20by%20swirling%20orange%20flames%2C%20warm%20orange%20gradient%20background%20with%20soft%20bokeh%20light%2C%20vibrant%20premium%20manga%20cover%20art%2C%20clean%20composition%2C%20highly%20detailed&width=400&height=560&seq=manga-cover-01&orientation=portrait",
    description:
      "废柴中学生沢田纲吉是黑手党彭格列家族第十代首领候选人,某天家里来了一位自称「家庭教师」的婴儿里包恩。在死气弹与同伴们的陪伴下,纲吉从「废柴阿纲」一步步成长为能守护身边人的合格首领,展开一段燃烧火焰的热血成长物语。",
    latestChapterId: "chap-hr-006",
    latestChapter: "第6话 黑曜战,六道骸",
    chaptersCount: 406,
    tags: ["热血", "黑手党", "成长", "火焰"],
    isHot: true,
    isNew: true,
    isFeatured: true,
  },
  {
    id: "naruto",
    title: "火影忍者",
    titleEn: "NARUTO -ナルト-",
    author: "岸本齐史",
    categories: ["hot-blooded", "shonen", "completed"],
    status: "已完结",
    rating: 9.6,
    views: "5.8亿",
    cover: "https://readdy.ai/api/search-image?query=Shonen%20manga%20cover%20illustration%20of%20a%20young%20ninja%20boy%20with%20spiky%20blond%20hair%20wearing%20an%20orange%20jumpsuit%20and%20a%20metal%20forehead%20protector%2C%20dynamic%20ninja%20pose%20with%20hand%20signs%2C%20warm%20sunset%20orange%20gradient%20background%2C%20vibrant%20premium%20manga%20cover%20art%2C%20clean%20composition%2C%20highly%20detailed&width=400&height=560&seq=manga-cover-02&orientation=portrait",
    description:
      "忍者少年鸣人从小被封印了九尾妖狐,立志成为火影并获得大家的认可。从吊车尾到拯救忍界的英雄,鸣人与佐助、小樱的第七班故事,是无数人青春里最热血的回忆。",
    latestChapterId: "chap-naruto-700",
    latestChapter: "第700话 漩涡鸣人!!",
    chaptersCount: 700,
    tags: ["忍者", "羁绊", "热血"],
    isHot: true,
  },
  {
    id: "one-piece",
    title: "海贼王",
    titleEn: "ONE PIECE",
    author: "尾田荣一郎",
    categories: ["hot-blooded", "shonen", "ongoing"],
    status: "连载中",
    rating: 9.7,
    views: "6.5亿",
    cover: "https://readdy.ai/api/search-image?query=Shonen%20manga%20cover%20illustration%20of%20a%20cheerful%20young%20pirate%20boy%20wearing%20a%20straw%20hat%20and%20red%20vest%20showing%20a%20confident%20grin%20with%20arms%20crossed%2C%20warm%20golden%20gradient%20background%2C%20vibrant%20premium%20manga%20cover%20art%2C%20clean%20composition%2C%20highly%20detailed&width=400&height=560&seq=manga-cover-03&orientation=portrait",
    description:
      "吃了橡胶果实的少年路飞,为了成为「海贼王」而扬帆出海。他与草帽一伙的伙伴们踏上伟大航路,追逐传说中的大秘宝 ONE PIECE,展开永不放弃的自由冒险。",
    latestChapterId: "chap-onepiece-1120",
    latestChapter: "第1120话 传说中的战士",
    chaptersCount: 1120,
    tags: ["冒险", "大海贼", "伙伴"],
    isHot: true,
  },
  {
    id: "bleach",
    title: "死神",
    titleEn: "BLEACH",
    author: "久保带人",
    categories: ["battle", "shonen", "completed"],
    status: "已完结",
    rating: 9.5,
    views: "3.9亿",
    cover: "https://readdy.ai/api/search-image?query=Shonen%20manga%20cover%20illustration%20of%20a%20calm%20teenage%20boy%20with%20black%20robes%20holding%20a%20giant%20katana%20over%20his%20shoulder%2C%20cool%20determined%20expression%2C%20warm%20gradient%20background%20with%20cherry%20petals%2C%20vibrant%20premium%20manga%20cover%20art%2C%20clean%20composition%2C%20highly%20detailed&width=400&height=560&seq=manga-cover-04&orientation=portrait",
    description:
      "高中生黑崎一护为保护家人获得了死神之力,从此背负斩魄刀穿梭于现世与尸魂界之间。虚、死神、灭却师,斩月之下的热血战斗拉开帷幕。",
    latestChapterId: "chap-bleach-686",
    latestChapter: "第686话 死神与虚与灭却师",
    chaptersCount: 686,
    tags: ["死神", "刀剑", "热血"],
  },
  {
    id: "gintama",
    title: "银魂",
    titleEn: "銀魂",
    author: "空知英秋",
    categories: ["school", "completed"],
    status: "已完结",
    rating: 9.3,
    views: "2.1亿",
    cover: "https://readdy.ai/api/search-image?query=Shonen%20manga%20cover%20illustration%20of%20a%20lazy%20samurai%20boy%20with%20silver%20curly%20hair%20holding%20a%20wooden%20sword%20and%20eating%20sweet%20bean%20paste%20bread%2C%20warm%20golden%20gradient%20background%2C%20vibrant%20premium%20manga%20cover%20art%2C%20clean%20composition%2C%20highly%20detailed&width=400&height=560&seq=manga-cover-05&orientation=portrait",
    description:
      "江户时代末期,外星人「天人」入侵地球。万事屋老板坂田银时和搭档们接下各种奇葩委托,在一本正经的恶搞与突如其来的热血之间反复横跳,笑中带泪的日常神作。",
    latestChapterId: "chap-gintama-704",
    latestChapter: "第704话 银魂",
    chaptersCount: 704,
    tags: ["搞笑", "武士", "日常"],
  },
  {
    id: "hunter",
    title: "全职猎人",
    titleEn: "HUNTER×HUNTER",
    author: "富坚义博",
    categories: ["hot-blooded", "battle", "ongoing"],
    status: "连载中",
    rating: 9.7,
    views: "2.6亿",
    cover: "https://readdy.ai/api/search-image?query=Shonen%20manga%20cover%20illustration%20of%20an%20energetic%20young%20boy%20with%20spiky%20green%20hair%20holding%20a%20fishing%20rod%20with%20an%20adventurous%20grin%2C%20warm%20amber%20gradient%20background%2C%20vibrant%20premium%20manga%20cover%20art%2C%20clean%20composition%2C%20highly%20detailed&width=400&height=560&seq=manga-cover-06&orientation=portrait",
    description:
      "为了寻找失踪的父亲,少年小杰踏上猎人考试之路,结识了酷拉皮卡、雷欧力和奇犽。念能力、幻影旅团、贪婪之岛……富坚义博构建的世界宏大而迷人。",
    latestChapterId: "chap-hunter-400",
    latestChapter: "第400话 黑暗大陆",
    chaptersCount: 400,
    tags: ["猎人", "念能力", "冒险"],
  },
  {
    id: "aot",
    title: "进击的巨人",
    titleEn: "進撃の巨人",
    author: "谏山创",
    categories: ["hot-blooded", "battle", "completed"],
    status: "已完结",
    rating: 9.4,
    views: "3.2亿",
    cover: "https://readdy.ai/api/search-image?query=Shonen%20manga%20cover%20illustration%20of%20a%20serious%20young%20soldier%20with%20short%20dark%20hair%20wearing%20a%20white%20shirt%20and%20green%20cloak%20with%20a%20determined%20gaze%2C%20warm%20ember%20orange%20gradient%20background%2C%20vibrant%20premium%20manga%20cover%20art%2C%20clean%20composition%2C%20highly%20detailed&width=400&height=560&seq=manga-cover-07&orientation=portrait",
    description:
      "人类蜷缩在三重高墙之内苟延残喘,超大型巨人一脚踹破墙壁的瞬间,少年艾伦的噩梦开始。自由、仇恨与真相,一部改变漫画格局的史诗级作品。",
    latestChapterId: "chap-aot-139",
    latestChapter: "第139话 迈向山丘上的那棵树",
    chaptersCount: 139,
    tags: ["巨人", "自由", "史诗"],
    isHot: true,
  },
  {
    id: "opm",
    title: "一拳超人",
    titleEn: "ワンパンマン",
    author: "ONE / 村田雄介",
    categories: ["hot-blooded", "ongoing"],
    status: "连载中",
    rating: 9.2,
    views: "2.8亿",
    cover: "https://readdy.ai/api/search-image?query=Shonen%20manga%20cover%20illustration%20of%20a%20bored%20bald%20hero%20in%20a%20yellow%20jumpsuit%20and%20white%20cape%20raising%20one%20fist%20casually%2C%20warm%20sunset%20gradient%20background%2C%20vibrant%20premium%20manga%20cover%20art%2C%20clean%20composition%2C%20highly%20detailed&width=400&height=560&seq=manga-cover-08&orientation=portrait",
    description:
      "光头琦玉以每天100个俯卧撑练就了无敌的一拳,任何怪人都在他的普通一拳下灰飞烟灭。然而变强的代价,是再也感受不到热血的空虚感,他与弟子杰诺斯的故事笑点与燃点并存。",
    latestChapterId: "chap-opm-230",
    latestChapter: "第230话 新英雄",
    chaptersCount: 230,
    tags: ["英雄", "搞笑", "战斗"],
  },
  {
    id: "jujutsu",
    title: "咒术回战",
    titleEn: "呪術廻戦",
    author: "芥见下下",
    categories: ["battle", "shonen", "ongoing"],
    status: "连载中",
    rating: 9.1,
    views: "2.4亿",
    cover: "https://readdy.ai/api/search-image?query=Shonen%20manga%20cover%20illustration%20of%20a%20cool%20teenage%20boy%20with%20pink%20spiky%20hair%20and%20a%20dark%20high%20collar%20hoodie%20with%20a%20confident%20smirk%2C%20warm%20magenta%20orange%20gradient%20background%2C%20vibrant%20premium%20manga%20cover%20art%2C%20clean%20composition%2C%20highly%20detailed&width=400&height=560&seq=manga-cover-09&orientation=portrait",
    description:
      "吞下特级咒物「两面宿傩之指」的高中生虎杖悠仁,从此成为咒术师。与伏黑惠、钉崎野蔷薇一起在东京咒术高专修行,对抗层出不穷的诅咒,生死一线的现代咒术大战。",
    latestChapterId: "chap-jujutsu-271",
    latestChapter: "第271话 死灭洄游,终局",
    chaptersCount: 271,
    tags: ["咒术", "诅咒", "战斗"],
  },
  {
    id: "kuroko",
    title: "黑子的篮球",
    titleEn: "黒子のバスケ",
    author: "藤卷忠俊",
    categories: ["school", "shonen", "completed"],
    status: "已完结",
    rating: 9.0,
    views: "1.8亿",
    cover: "https://readdy.ai/api/search-image?query=Shonen%20manga%20cover%20illustration%20of%20a%20quiet%20teenage%20basketball%20player%20with%20light%20blue%20hair%20dribbling%20a%20basketball%20in%20an%20orange%20basketball%20uniform%2C%20warm%20golden%20gradient%20background%2C%20vibrant%20premium%20manga%20cover%20art%2C%20clean%20composition%2C%20highly%20detailed&width=400&height=560&seq=manga-cover-10&orientation=portrait",
    description:
      "存在感极低却擅长传球的黑子哲也,与火神大我组成「光与影」的搭档,向「奇迹的世代」们所在的强校发起挑战。纯粹的篮球热血,燃到最后一秒。",
    latestChapterId: "chap-kuroko-275",
    latestChapter: "第275话 光与影",
    chaptersCount: 275,
    tags: ["篮球", "青春", "热血"],
  },
  {
    id: "shokugeki",
    title: "食戟之灵",
    titleEn: "食戟のソーマ",
    author: "附田祐斗 / 佐伯俊",
    categories: ["school", "shonen", "completed"],
    status: "已完结",
    rating: 9.1,
    views: "1.6亿",
    cover: "https://readdy.ai/api/search-image?query=Shonen%20manga%20cover%20illustration%20of%20a%20passionate%20young%20chef%20with%20red%20hair%20in%20a%20white%20chef%20uniform%20holding%20a%20spatula%20with%20cooking%20flames%20behind%20him%2C%20warm%20orange%20gradient%20background%2C%20vibrant%20premium%20manga%20cover%20art%2C%20clean%20composition%2C%20highly%20detailed&width=400&height=560&seq=manga-cover-11&orientation=portrait",
    description:
      "来自大众食堂的少年厨师幸平创真,凭着一股不服输的劲头闯入料理界的顶点「远月学园」。一次次食戟对决、一道道香气四溢的料理,看得人直流口水。",
    latestChapterId: "chap-shokugeki-325",
    latestChapter: "第325话 料理人的世界",
    chaptersCount: 325,
    tags: ["美食", "料理", "校园"],
  },
  {
    id: "fairy-tail",
    title: "妖精的尾巴",
    titleEn: "FAIRY TAIL",
    author: "真岛浩",
    categories: ["battle", "hot-blooded", "completed"],
    status: "已完结",
    rating: 9.2,
    views: "2.2亿",
    cover: "https://readdy.ai/api/search-image?query=Shonen%20manga%20cover%20illustration%20of%20a%20cheerful%20teenage%20mage%20girl%20with%20long%20pink%20hair%20in%20a%20blue%20dress%20with%20a%20small%20white%20cat%20on%20her%20shoulder%2C%20warm%20golden%20gradient%20background%2C%20vibrant%20premium%20manga%20cover%20art%2C%20clean%20composition%2C%20highly%20detailed&width=400&height=560&seq=manga-cover-12&orientation=portrait",
    description:
      "魔导士公会「妖精的尾巴」聚集了一群爱闯祸又重情义的魔法师。纳兹、露西、格雷、艾露莎和快乐,一起接下任务、对抗黑暗公会,友情与魔法共同燃烧。",
    latestChapterId: "chap-fairytail-545",
    latestChapter: "第545话 妖精的尾巴,永远",
    chaptersCount: 545,
    tags: ["魔法", "公会", "友情"],
  },
];

export interface LatestUpdate {
  mangaId: string;
  chapterId: string;
  chapterTitle: string;
  time: string;
}

export const latestUpdates: LatestUpdate[] = [
  { mangaId: "hitman-reborn", chapterId: "chap-hr-006", chapterTitle: "第6话 黑曜战,六道骸", time: "今天 09:12" },
  { mangaId: "one-piece", chapterId: "chap-onepiece-1120", chapterTitle: "第1120话 传说中的战士", time: "今天 08:30" },
  { mangaId: "jujutsu", chapterId: "chap-jujutsu-271", chapterTitle: "第271话 死灭洄游,终局", time: "今天 07:45" },
  { mangaId: "hunter", chapterId: "chap-hunter-400", chapterTitle: "第400话 黑暗大陆", time: "昨天 22:18" },
  { mangaId: "naruto", chapterId: "chap-naruto-700", chapterTitle: "第700话 漩涡鸣人!!", time: "昨天 20:05" },
  { mangaId: "opm", chapterId: "chap-opm-230", chapterTitle: "第230话 新英雄", time: "昨天 18:40" },
  { mangaId: "aot", chapterId: "chap-aot-139", chapterTitle: "第139话 迈向山丘上的那棵树", time: "前天 21:00" },
  { mangaId: "bleach", chapterId: "chap-bleach-686", chapterTitle: "第686话 死神与虚与灭却师", time: "前天 19:26" },
];